module.exports = __webpack_public_path__ + "static/media/daily.4ec4d6a7.jpg";